import { render, staticRenderFns } from "./customerScale.vue?vue&type=template&id=6c6dd89d&scoped=true"
import script from "./customerScale.vue?vue&type=script&lang=js"
export * from "./customerScale.vue?vue&type=script&lang=js"
import style0 from "./customerScale.vue?vue&type=style&index=0&id=6c6dd89d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6dd89d",
  null
  
)

export default component.exports